import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Project } from 'src/app/shared/models/project.model';

@Component({
    selector: 'app-project-sidebar',
    templateUrl: './project-sidebar.component.html',
    styleUrl: './project-sidebar.component.scss',
    standalone: false
})
export class ProjectSidebarComponent {
	public isCollapsed = false;
	@Input() projects: Project[] = [];
	@Input() plan_usage: number = 0;
	@Output() showSidebarEvent = new EventEmitter();


	closeSideBar(){
    this.showSidebarEvent.emit(false);
  }
}
